/* 
// ADDS JUDGE.ME VERIFIED BADGE TO PRODUCT PAGE REVIEWS

document.addEventListener("DOMContentLoaded", () => {
  const addVerifiedBadges = () => {
    document.querySelectorAll('.jdgm-rev__author-wrapper').forEach(wrapper => {
      if (wrapper.dataset.badgeAdded === "true") return;

      setTimeout(() => {
        if (!wrapper.querySelector('.jdgm-rev__buyer-badge-wrapper')) {
          const badgeWrapper = document.createElement('span');
          badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';

          const badge = document.createElement('span');
          badge.className = 'jdgm-rev__buyer-badge';

          badgeWrapper.appendChild(badge);
          wrapper.appendChild(badgeWrapper);
        }
        wrapper.dataset.badgeAdded = "true";
      }, 1000); // Short delay to ensure dynamic badges have loaded
    });
  };

  addVerifiedBadges();

  const observer = new MutationObserver(addVerifiedBadges);
  observer.observe(document.body, { childList: true, subtree: true });

  const intervalId = setInterval(addVerifiedBadges, 500);
  setTimeout(() => clearInterval(intervalId), 10000);
});
*/



// CONSOLIDATED FUNCTION: UPDATES STOCK & PRICING AFTER USER CHANGES VARIANT SELECTOR

/**
 * VARIANT SELECTOR DYNAMIC CONTENT UPDATE
 *
 * PURPOSE:
 * Updates variant-related content dynamically without requiring a full page reload.
 *
 * HOW IT WORKS:
 * - Listens to changes on the product variant selector (HTML ID: "gs-variant-selector").
 * - Upon variant change:
 *    1. Immediately hides the variant pricing container ("#variant-price-container") to avoid displaying incorrect information during fetch.
 *    2. Makes an AJAX call to Shopify to fetch updated variant content based on the newly selected variant.
 *    3. Updates two pieces of information upon successful fetch:
 *       - Stock availability message (".stock-status").
 *       - Variant pricing and savings display ("#variant-price-container").
 *    4. Re-displays the pricing container, managing visibility based on whether the variant is the default (no blades) or includes blade bundles.
 *
 * IMPORTANT NOTES:
 * - Requires Liquid snippet "variant pricing display" to be implemented with correct IDs/classes.
 * - Fetch request delay (currently 50ms) helps ensure Shopify variant selection scripts complete execution smoothly before updating content.
 */

document.addEventListener("DOMContentLoaded", () => {
  const variantContainer = document.getElementById('gs-variant-selector');
  if (!variantContainer) return;

  const selects = variantContainer.querySelectorAll('select');
  const currentVariantPricing = document.querySelector('#variant-price-container');

  const updateVariantContent = () => {
    // Immediately hide pricing container during fetch
    if (currentVariantPricing) currentVariantPricing.style.display = 'none';

    setTimeout(() => {
      const hiddenVariantInput = variantContainer.querySelector('input[name="id"]');
      if (!hiddenVariantInput || !hiddenVariantInput.value) return;

      const selectedVariantId = hiddenVariantInput.value;

      fetch(`${window.location.pathname}?variant=${selectedVariantId}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // STOCK UPDATE
          const newStockMessage = doc.querySelector('.stock-status');
          const currentStockMessage = document.querySelector('.stock-status');
          if (newStockMessage && currentStockMessage) {
            currentStockMessage.innerHTML = newStockMessage.innerHTML;
          }

          // PRICING UPDATE
          const newVariantPricing = doc.querySelector('#variant-price-container');

          if (newVariantPricing && currentVariantPricing) {
            currentVariantPricing.innerHTML = newVariantPricing.innerHTML;
            currentVariantPricing.style.display = newVariantPricing.style.display || 'block';
          }
        })
        .catch(err => {
          console.error('Fetch error:', err);
          if (currentVariantPricing) currentVariantPricing.style.display = 'none';
        });
    }, 50); // your optimized delay
  };

  selects.forEach(select => {
    select.addEventListener('change', updateVariantContent);
  });
});



// REFRESH JUDGE.ME WIDGET AT BOTTOM OF PADE TO DEAL WITH PAGINATION ERROR (PAGE NOT FOUND)
document.addEventListener("DOMContentLoaded", () => {
  
  const setupPagination = () => {
    const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
    const paginateContainer = document.querySelector('.jdgm-paginate');

    if (!reviewsContainer || !paginateContainer) return;

    const apiUrl = paginateContainer.dataset.url;
    const perPage = paginateContainer.dataset.perPage || 5;

    const loadPage = (page) => {
      fetch(`${apiUrl}?page=${page}&per_page=${perPage}&sort_by=most-recent`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => res.text())
      .then(html => {
        reviewsContainer.innerHTML = html;
        setupPagination(); // Re-setup pagination for the new page
        window.scrollTo({ top: reviewsContainer.offsetTop - 100, behavior: 'smooth' });
      })
      .catch(err => console.error("Pagination fetch failed:", err));
    };

    document.querySelectorAll('.jdgm-paginate__page').forEach(link => {
      link.onclick = (e) => {
        e.preventDefault();
        const page = link.dataset.page;
        if (page) loadPage(page);
      };
    });

    console.log("Custom Judge.me pagination initialized.");
  };

  const observer = new MutationObserver((_, obs) => {
    if (document.querySelector('.jdgm-paginate__page')) {
      setupPagination();
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// HIDE SCROLL BARS ON JUDGE.ME MEDALS

document.addEventListener("DOMContentLoaded", () => {
  const medalsContainers = document.querySelectorAll('.jdgm-medals .jdgm-medals__container');
  
  medalsContainers.forEach(container => {
    container.style.overflow = 'hidden';
  });

  console.log("Scrollbars removed from Judge.me medals containers.");
});

